// const baseUrl = 'http://172.16.0.86:8080'
const baseUrl = 'http://www.starsine.cn:8090'
const imgServerUrl = 'http://home.starsine.cn/'

export default {baseUrl,imgServerUrl}


//////////////////
// WEBPACK FOOTER
// ./static/baseUrl.js
// module id = rjmm
// module chunks = 1 2 3 4 5 6 7 8